export const addUnit = (val: string | number) => {
  return typeof val === 'string' ? val : val + 'px'
}
